import { TFunction } from 'i18next';

import { getFile } from './dao/ManagementDao';

export interface AttachedFile {
  url: string | null;
  info: string | null;
  error: string | null;
}

/**
 * Get a file from a backend service that requires user authentication.
 * @param token JWT token containing the user's permissions.
 * @param enquiryId ID of the enquiry that own the file (document).
 * @param fileName Name of the file to retrieve.
 * @param t Translation function from i18n.
 */
export const getAttachedFile = async (
  token: string,
  enquiryId: string,
  fileName: string,
  t: TFunction,
): Promise<AttachedFile> => getFile(token, enquiryId, fileName)
  .then((response) => {
    const contentType = response.headers['content-type'];
    const binaryData: BlobPart[] = [response.data];
    return {
      url: window.URL.createObjectURL(new Blob(binaryData, { type: contentType })),
      info: null,
      error: null
    };
  })
  .catch((error) => {
    if (error.status === 410) return {
      url: null,
      info: `${t('file.service.get.file.gone')}`,
      error: null
    };
    else return {
      url: null,
      info: null,
      error: `${t('file.service.get.file.error')}: ${error}`
    };
  });
